module.exports = __webpack_public_path__ + "static/img/app_back.83f33d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/app_back.png
// module id = cEOM
// module chunks = 0